






































import { Component, Vue, Prop, Emit } from "vue-property-decorator";
import { Usuario } from "@/typings/store/plugins/easyFirestore/usuarios";

@Component
export default class InfoUsuario extends Vue {
  @Prop() readonly usuario!: Usuario;
  @Prop({ type: Boolean }) readonly showTitulo!: boolean;

  get id(): string {
    return this.usuario.id || "Sin registro";
  }

  get nombre(): string {
    return this.usuario.nombre || "Sin nombre";
  }

  get rut(): string {
    return this.usuario.rut || "Sin RUT";
  }

  get email(): string {
    return this.usuario.email || "Sin correo";
  }

  get tipo(): string {
    return this.usuario.tipo || "";
  }

  get activo(): boolean {
    return this.usuario.estado === "libre";
  }

  get tipoLegible(): string {
    const roles: Record<string, string> = {
      admin: "Administrador",
      supervisor: "Supervisor",
      relator: "Relator",
      cliente: "Cliente",
      operador: "Operador",
      administrador_locales: "Administrador de locales",
      gerente_general: "Gerente general",
      gerente_operaciones: "Gerente de operaciones",
      gerente_comercial: "Gerente comercial",
    };
    return roles[this.tipo] || this.tipo || "Sin rol";
  }

  @Emit("cerrar")
  onCerrar(): void {
    return;
  }
}
